import { h, Component } from 'preact';



export default class Footer extends Component {
	render() {
		
		return (
			
					<footer>
						<a target="_blank" href="https://instagram.com/kidsuper" >
    <img class="sig" src="" />
</a>
          </footer>
		
		);
	}
}



// WEBPACK FOOTER //
// ./components/footer/index.js